import HttpClient from './instance'

export const GET_PRODUCTS = async () =>
    HttpClient({
        method: 'get',
        url: `/admin/products`,
    })

export const GET_CURRENCIES = async () =>
    HttpClient({
        method: 'get',
        url: `/admin/products/currencies`,
    })
export const EDIT_CURRENCY = async (id, { currency, symbol }) =>
    HttpClient({
        method: 'put',
        url: `/admin/products/currency`,
        params: {
            id,
        },
        data: {
            currency,
            symbol,
        },
    })
export const CREATE_CURRENCY = async ({ currency, symbol }) =>
    HttpClient({
        method: 'post',
        url: `/admin/products/currency`,
        data: {
            currency,
            symbol,
        },
    })

export const GET_COUNTRIES_CURRENCY = async () =>
    HttpClient({
        method: 'get',
        url: `/admin/products/country-currency`,
    })
export const CREATE_COUNTRY_CURRENCY = async ({ countryCode, currency }) =>
    HttpClient({
        method: 'post',
        url: `/admin/products/country-currency`,
        data: {
            countryCode,
            currency,
        },
    })
export const UPDATE_COUNTRY_CURRENCY = async (id, { countryCode, currency }) =>
    HttpClient({
        method: 'put',
        url: `/admin/products/country-currency`,
        params: {
            id,
        },
        data: {
            countryCode,
            currency,
        },
    })
export const DELETE_COUNTRY_CURRENCY = async id =>
    HttpClient({
        method: 'delete',
        url: `/admin/products/country-currency`,
        params: {
            id,
        },
    })

export const UPDATE_PRODUCT_PRICE = async (id, { productCode, newPrice, currency, isInflatedPrice = false }) =>
    HttpClient({
        method: 'patch',
        url: `/admin/products/${id}/price`,
        data: {
            productCode,
            newPrice,
            currency,
            isInflatedPrice,
        },
    })

export const DELETE_PRODUCT_PRICE = async (id, { productCode, currency, isInflatedPrice = false }) =>
    HttpClient({
        method: 'delete',
        url: `/admin/products/${id}/price`,
        data: {
            productCode,
            currency,
            isInflatedPrice,
        },
    })
